.stepper:hover {
  cursor: pointer;
}
